<script>
  export let testId = null;

</script>

<div
  data-cy={testId}
  style="margin: 1rem; 
    display: flex;
    justify-content: center;
    align-items: center;"
>
  <slot />
</div>
